import React, { useState } from "react";
import Title from "../../Other/Title";
import Avatar from "../../../assets/images/avatar.png";
import PenContactSVG from "../../../assets/icons/pen";
import { FaLinkedin, FaGithub, FaMedium, FaFigma } from "react-icons/fa";
import { motion } from "framer-motion";
import { useLanguage } from "../../../i18n/LanguageContext";

const Contact = () => {
  const { t } = useLanguage();
  const [isHovered, setIsHovered] = useState(false);

  const socialLinks = [
    {
      id: 1,
      name: "Linkedin",
      icon: <FaLinkedin />,
      link: "https://www.linkedin.com/in/azateser",
      mobileShow: true,
    },
    {
      id: 2,
      name: "Github",
      icon: <FaGithub />,
      link: "https://github.com/azateser",
      mobileShow: true,
    },
    {
      id: 3,
      name: "Medium",
      icon: <FaMedium />,
      link: "https://medium.com/@azatesser",
      mobileShow: false,
    },
    {
      id: 4,
      name: "Figma",
      icon: <FaFigma />,
      link: "",
      mobileShow: false,
    },
  ];

  // Waving hand animation variants
  const waveAnimation = {
    initial: { rotate: 0 },
    animate: {
      rotate: [0, 14, -8, 14, -4, 10, 0],
      transition: {
        duration: 2.5,
        repeat: Infinity,
        repeatType: "loop",
        repeatDelay: 1,
        ease: "easeInOut"
      }
    }
  };

  return (
    <div className="font-inter mt-52" id="contact">
      <Title title={t.contact.title} />

      <div 
        className="mt-2  md:-mt-80 m-auto z-20 lg:flex justify-start mb-20 relative overflow-hidden lg:max-w-[860px] transition-all duration-1000 ease-in-out shadow-default hover:drop-shadow-glow lg:p-12 p-8 hover:border-[rgb(116,56,255)] bg-[rgba(7,6,14,0.6)] hover:backdrop-blur-none hover:bg-[rgba(7,6,14,0.9)] rounded-lg backdrop-blur-xl border-[rgba(67,65,85,0.25)] border-[0.5px]"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="lg:w-3/5">
          <div className="flex items-center gap-6">
            <div className="lg:w-10 w-14 relative">
              <img className="lg:w-10 w-14" src={Avatar} alt="Azat ESER" />
              <motion.img
                animate={{
                  scale: isHovered ? 1.7 : 1
                }}
                transition={{ duration: 1, ease: "easeInOut" }}
                className="top-0 left-0 absolute"
                src="https://framerusercontent.com/images/jXNTYW9Hl33zlKD406oHIUUfROI.png"
                alt=""
              />
            </div>
            <motion.div 
              animate={{
                x: isHovered ? 8 : 0
              }}
              transition={{ duration: 1, ease: "easeInOut" }}
              whileHover={{ scale: 1.05 }}
              className="flex items-center gap-2 bg-[linear-gradient(rgba(130,130,138,0.2)0%,rgba(130,130,138,0.14)100%)] border-[rgba(255,255,255,0.13)] border backdrop-blur-xl rounded-full lg:text-xs text-base font-medium text-[rgba(245,245,245,0.8)] px-4 py-2"
            >
              <div className="w-[6px] h-[6px] border-[rgb(108,219,110)] rounded-full border bg-[rgb(10,143,13)]"></div>
              {t.contact.available}
            </motion.div>
          </div>
          <div className="mt-8 w-full">
            <div className="text-lg font-semibold flex items-center gap-2">
              {t.contact.line}{" "}
              <motion.span 
                className="inline-block origin-bottom-right text-xl"
                variants={waveAnimation}
                initial="initial"
                animate="animate"
              >
                👋
              </motion.span> 
              {t.contact.social}
            </div>
            <div className="text-[rgba(255,255,255,0.4)] mt-4 text-sm lg:w-4/5">
              {t.contact.blurb}
            </div>
          </div>
        </div>

        <div className="flex flex-col lg:align-bottom align-middle lg:justify-end justify-center lg:mt-0 mt-8">
          <div className="flex items-center lg:gap-4 gap-3 lg:justify-normal justify-center">
            {socialLinks.map((item) => (
              <motion.li
                key={item.id}
                whileHover={{ scale: 1.15, opacity: 1 }}
                whileTap={{ scale: 0.95 }}
                className={`lg:flex list-none text-2xl items-center justify-center w-12 h-12 opacity-50 hover:opacity-100 cursor-pointer transition-all rounded-md hover:bg-[#201f30]`}
              >
                <a href={item.link} target="_blank" rel="noreferrer" aria-label={`Azat ESER on ${item.name}`} title={item.name}>{item.icon}</a>
              </motion.li>
            ))}
          </div>
          <motion.a
            href="mailto:azatesser@gmail.com"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            animate={{
              backgroundColor: isHovered ? "rgb(116,56,255)" : "rgb(32,31,47)"
            }}
            transition={{ duration: 0.8, ease: "easeInOut" }}
            className="font-semibold text-sm text-center py-5 lg:mt-4 mt-4 rounded-lg hover:shadow-lg"
          >
            azatesser@gmail.com
          </motion.a>
        </div>

        <motion.div
          animate={{
            opacity: isHovered ? 0.3 : 0.7,
            filter: isHovered ? "invert(1)" : "invert(0)"
          }}
          transition={{ duration: 1.2, ease: "easeInOut" }}
          className="-z-10 lg:-top-6 -top-20 lg:-right-[6.5rem] -right-32 absolute"
        >
          <PenContactSVG />
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;
